const addClass = (elmnt, className) => { elmnt.classList.add(className) };
const removeClass = (elmnt, className) => { elmnt.classList.remove(className) };

export {
  addClass,
  removeClass
}
